import { useEffect, useRef, useState } from 'react';

// eslint-disable-next-line import/prefer-default-export
export const useShowMoreButton = () => {
  const targetRef = useRef();
  const [shouldShowButton, setShowButton] = useState(false);

  useEffect(() => {
    const checkShowButton = () => {
      if (!targetRef.current) return;
      const showButton =
        targetRef.current.scrollHeight > targetRef.current.clientHeight;
      setShowButton(showButton);
    };

    checkShowButton();

    window.addEventListener('resize', checkShowButton);

    return () => {
      window.removeEventListener('resize', checkShowButton);
    };
  }, []);

  return [targetRef, shouldShowButton];
};
